import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "Python Developer",
          "Machine Learning Engineer",
          "MERN Stack Developer",
          "Open Source Contributor",
          "Bot Master",
          "Linux Enthusiast",
          "Bayede",
          "Wena We Ndlovu"
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
